export default __webpack_public_path__ + "static/media/homeowner-hero.04acca0d.jpg";